import { render } from "./UserChatModal.vue?vue&type=template&id=012824e4&scoped=true"
import script from "./UserChatModal.vue?vue&type=script&lang=js"
export * from "./UserChatModal.vue?vue&type=script&lang=js"

import "./UserChatModal.vue?vue&type=style&index=0&id=012824e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012824e4"]])

export default __exports__